import { useTranslationContext } from 'hooks';

import Button from 'shared/Button';
import Icons from 'shared/Icons';
import Modal from 'shared/Modal';

import classes from './CompletionModal.module.scss';

export default function CompletionModal(props: {
  handleClose: () => void;
  magicLinkSent: boolean;
}) {
  const { handleClose, magicLinkSent } = props;
  const { t } = useTranslationContext();

  return (
    <Modal visible={true} toggle={handleClose}>
      <div className={classes.wrapper}>
        <Icons iconType="check-circle" iconClass={classes.checkIcon} />

        <p>{t("Thanks for your question!")}</p>
        {magicLinkSent &&
          <>
            <p>{t("A confirmation email has been sent your way")}</p>
          </>
        }

        <Button
          customClass={classes.doneButton}
          callback={() => handleClose()}
          text={t("Done")}
        />
      </div>
    </Modal>
  );
}
